import React, { Component } from "react";
import DatePicker from "react-datepicker";
import ReactTable from "react-table";
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import request from "../../../lib/requester";
import _, { toNumber } from "lodash";
import moment from "moment";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import Autocomplete from "../../../component/autocomplete";
import axios from "axios";
import requester from "../../../lib/requester";

class SendDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sDest: "CAB",
      sCustomerId: "",
      sCustomerName: "",
      sCabangId: "",
      sCabangName: "",
      sScanResult: "",
      sScan: "",
      sAwbNumber: "",
      // sAwbDate: new Date(),
      sAwbDate: "",
      sDocNumber: "",
      sDocDate: new Date(),
      lovCabang: [],
      user: JSON.parse(window.localStorage.getItem("is_user")),
      branchCollection: "",
      error: [],
      success: "",
      errorscan: 0,
      dataTable: [],
      loading: false,
      sDocType: "INV",
      sDatainsert: [],
      filePATH: "",
      submitted_stat: false,
      sRO: "N",
      sPopular_name: "",
    };
  }

  componentDidMount = () => {
    this.getBranch();
  };

  handleChangeDest = (e) => {
    // alert(e.target.value);
    // this.state.sDest = e.target.value;

    this.setState({ sDest: e.target.value });
    this.setState({
      sCustomerId: "",
      sCabangId: "",
      sCustomerName: "",
      sPopular_name: "",
      sCabangName: "",
      sRO: e.target.value == "RO" ? "Y" : "N",
    });
    // document.getElementById("branclov").value = "";
  };

  handleChangeDoctype = (e) => {
    this.setState({ sDocType: e.target.value });
  };

  handleInsert = (e) => {
    // alert("ok");

    // this.setState({sDatainsert: this.state.dataTable});
    let datainsert = this.state.dataTable;
    console.log(datainsert);
    console.log("before");

    if (this.state.sScanResult.length > 0) {
      console.log(this.state.sCustomerName);
      console.log(this.state.sScanResult);

      if (this.state.sDest === "CAB") {
        this.state.branchCollection =
          this.state.sCabangId + "," + this.state.user.org_id;
      } else {
        this.state.branchCollection = this.state.user.org_id;
      }

      // Claim To Oracle
      let url = "/api/orafin/v1/collection/get-invoice-and-ttf";
      let { sScanResult, branchCollection, sDocType } = this.state;
      // let invoiceArr = this.state.listInvoice.map((item, index) => {
      //   return item.invoice_id + "*" + parseInt(item.invoice_amount);
      // });
      let param = {
        datascan: sScanResult,
        branchid: branchCollection,
        doctype: sDocType,
        customer_id: this.state.sCustomerId,
      };
      this.setState({ loading: true });
      request.postOracle(url, param, {
        success: function (response) {
          // this.handleApprove();
          let { data } = response.data;

          let dataline = data;

          dataline.map((item, index) => {
            if (this.cekinvoiceNoExist(item.CUSTOMER_TRX_ID)) {
              datainsert.push({
                CUSTOMER_ID: item.CUSTOMER_ID,
                CUSTOMER_NAME: item.CUSTOMER_NAME,
                POPULAR_NAME: item.POPULAR_NAME_CUSTOMER,
                CUSTOMER_TRX_ID: item.CUSTOMER_TRX_ID,
                TRX_NUMBER: item.TRX_NUMBER,
                TTF_NO: item.TTF_NO == "x" ? "" : item.TTF_NO,
                AMOUNT: item.AMOUNT,
                TRX_DATE: item.TRX_DATE,
                DUE_DATE: item.DUE_DATE,
                PO_NUMBER: item.PO_NUMBER,
                FAKTUR_PAJAK: item.FAKTUR_PAJAK,
              });
            }
          });

          // console.log(dataline);
          this.setState({
            loading: false,
            // dataTable: data,
          });

          // if (this.cekinvoiceNoExist(dataline.customer_trx_id)) {
          //   // datainsert.push(dataline);
          //   datainsert.push({
          //     CUSTOMER_ID: dataline.CUSTOMER_ID,
          //     CUSTOMER_NAME: dataline.CUSTOMER_NAME,
          //     CUSTOMER_TRX_ID: dataline.CUSTOMER_TRX_ID,
          //     TRX_NUMBER: dataline.TRX_NUMBER,
          //     TTF_NO: dataline.TTF_NO,
          //   });
          // }

          console.log(datainsert);
          console.log("after");
          // alert(this.cekinvoiceNoExist(dataline.customer_trx_id));

          // // dataTable.push(data);
          // console.log(datainsert);


          this.setState({ dataTable: datainsert.reverse() });
          // console.log(this.state.dataTable);
        }.bind(this),
        error: function (e) {
          alert("Failed to checking data");
        },
      });
    } else {
      alert("Please Scan Document..");
    }
  };

  cekinvoiceNoExist = (trx_id) => {
    let find = _.find(this.state.dataTable, function (o) {
      return o.CUSTOMER_TRX_ID === trx_id;
    });
    return find ? false : true;
  };

  renderSite = () => {
    // alert("tes");

    if (this.state.sDest === "CAB") {
      return (
        <div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Branch
            </label>
            <div className="col-sm-8">
              <select
                className="form-control"
                name="branchlov"
                id="branclov"
                onChange={this.handleChangeBranch.bind(this)}
              >
                <option value="0" text="0">
                  -Select Branch-
                </option>
                {this.state.lovCabang.map((item, index) => (
                  <option
                    value={item.org_id}
                    text={item.org_name}
                    // text={item.org_name}
                    key={index}
                  // selected={
                  //   this.state.sCabangId == item.org_id ? true : false
                  // }
                  >
                    {item.org_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      );
    }
    if (this.state.sDest === "CUS") {
      return (
        <div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Customer
            </label>
            <div className="col-sm-8">
              {/* <div className="col-sm-9"> */}
              <Autocomplete
                onchange={this.onChangeAutocompleteCust.bind(this)}
                onselect={this.onSelectCustomer.bind(this)}
                style={{
                  width: "100%",
                  height: "100%",
                  // backgroundColor: "gray",
                  //   color: "gray",
                }}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
      );
    }

    if (this.state.sDest === "RO") {
      this.state.sCabangId = this.state.user.org_id;
      this.state.sCabangName = this.state.user.org_name;
      return (
        <div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Branch
            </label>
            <div className="col-sm-8">
              {/* <div className="col-sm-9"> */}
              <input
                type="text"
                id="RO"
                disabled
                value={this.state.user.org_name}
                style={{
                  width: "100%",
                  height: "100%",
                  // backgroundColor: "gray",
                  //   color: "gray",
                }}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
      );
    }
  };

  onSelectCustomer = (suggestions, index) => {
    this.state.sCustomerId = suggestions.value ? suggestions.value : null;
    this.state.sCustomerName = suggestions.text ? suggestions.text : null;
    this.state.sPopular_name = suggestions.name ? suggestions.name : null;

    console.log(this.state.sPopular_name);
  };

  handleChangeBranch = (e) => {
    this.state.sCabangId = e.target.value;

    this.state.lovCabang.map((item, index) => (
      e.target.value == item.org_id ? (this.state.sCabangName = item.org_name, item) : item
    ));

    console.log(this.state.sCabangName);
  };

  getBranch = () => {
    let url = "/arman/v1/general/organization";
    requester.getArman(url, {
      success: function (response) {
        this.setState({ lovCabang: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  onChangeAutocompleteCust = (q) => {
    let param = {
      branch_id: this.state.user.org_id,
      customer_name: q,
    };
    let container = [];
    return new Promise((resolve) => {
      request.postOracle("/api/orafin/v1/collection/customer", param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.CUSTOMER_NAME;
            item.value = item.CUSTOMER_ID;
            item.name = item.POPULAR_NAME_CUSTOMER;
            return item;
          });
          resolve(container);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  };

  handleKeyDown = (e) => {
    // alert("ok");

    if (
      e.key === "Enter" ||
      e.keyCode === 13 ||
      e.key === "Tab" ||
      e.keyCode === 9
    ) {
      e.preventDefault();
      if (this.validateScan()) {
        if (e.target.value.length > 0) {
          // alert("enter");
          this.state.sScanResult =
            // this.state.sScanResult.length > 0
            //   ? this.state.sScanResult + "," + "'" + e.target.value + "'"
            //   : "'" + e.target.value + "'";
            "'" + e.target.value + "'";
          console.log(this.state.sScanResult);
          document.getElementById("scanfield").value = "";
          // document.getElementById("scanresult").value = this.state.sScanResult;
          this.handleInsert();
        }
      }
    }
  };

  handleChangeAwb = (e) => {
    this.state.sAwbNumber = e.target.value;
  };

  handleChangeAwbDate = (date) => {
    this.setState({ sAwbDate: date });
  };

  handleChangeDoc = (e) => {
    this.state.sDocNumber = e.target.value;
  };

  handleChangeDocDate = (date) => {
    this.setState({ sDocDate: date });
  };

  validateScan = () => {
    // alert("tes");
    this.state.errorscan = 0;
    if (this.state.sDest == "CAB") {
      // alert(this.state.sCabangId);
      if (this.state.sCabangId.length === 0) {
        alert("Please select Branch");
        this.state.errorscan = 1;
      }
    }

    if (this.state.sDest == "CUS") {
      if (this.state.sCustomerId.length === 0) {
        alert("Please select customer");
        this.state.errorscan = 1;
      }
    }

    // if (this.state.sAwbNumber.length === 0) {
    //   alert("Please input AWB Number");
    //   this.state.errorscan = 1;
    // }
    // if (this.state.sAwbDate.length === 0) {
    //   alert("Please input AWB Date");
    //   this.state.errorscan = 1;
    // }

    if (this.state.sDocType.length === 0) {
      alert("Please select Doc Type");
      this.state.errorscan = 1;
    }
    if (this.state.errorscan > 0) {
      document.getElementById("scanfield").value = "";
    }

    return true;
  };

  validateSubmit = () => {
    let error = [];

    if (this.state.sDest == "CAB") {
      if (this.state.sCabangId.length === 0) {
        error.push("Please select Branch");
      }
    }

    if (this.state.sDest == "CUS") {
      if (this.state.sCustomerId.length === 0) {
        error.push("Please select customer");
      }
    }

    // if (this.state.sAwbNumber.length === 0) {
    //   error.push("Please input AWB Number");
    // }
    // if (this.state.sAwbDate.length === 0) {
    //   error.push("Please input AWB Date");
    // }

    if (this.state.sScanResult.length === 0) {
      error.push("Please scan document");
    }

    if (error.length > 0) {
      document.getElementById("scanfield").value = "";
    }

    if (error.length > 0) {
      this.setState({ error: error });
      window.scrollTo(0, 0);
      console.log(this.state.error);
      return false;
    } else {
      return true;
    }
  };

  renderScan = () => {
    return (
      <div className="row">
        <div className="col-md-6">
          {/* <div className="form-group row">
            <label
              htmlFor="inputEmail3"
              className="col-sm-3 col-form-label"
            ></label>
            <div className="col-sm-9">
              <textarea
                disabled
                id="scanresult"
                cols="120"
                rows="5"
                // onChange={this.handleChangeInput.bind(this)}
                // value={this.state.sScanResult}
              />
            </div>
          </div> */}
        </div>
      </div>
    );
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "Invoice No.",
          accessor: "TRX_NUMBER",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),

          //   width: 150,
          Cell: (row) => (
            <div style={{ textAlign: "center" }}>
              <span>{row.value}</span>
            </div>
          ),
        },
        {
          Header: "TTF No.",
          accessor: "TTF_NO",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),

          //   width: 150,
          Cell: (row) => (
            <div style={{ textAlign: "center" }}>
              <span>{row.value}</span>
            </div>
          ),
        },
        {
          Header: "Customer Name",
          accessor: "CUSTOMER_NAME",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),

          //   width: 150,
          Cell: (row) => (
            <div style={{ textAlign: "left" }}>
              <span>{row.value}</span>
            </div>
          ),
        },
        {
          Header: "Action",
          accessor: "CUSTOMER_TRX_ID",

          Cell: (row) => {
            return (
              <div style={{ textAlign: "center", color: "blue" }}>
                <span>
                  {/* <button
                  className="btn btn-info btn-sm"
                  onClick={() => {
                    this.deleteLine(row.value);
                  }}
                >
                  Remove
                </button> */}
                  {/* <a onClick={() => this.deleteLine(row.value)}>Remove</a> */}
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => {
                      this.deleteLine(row.value);
                    }}
                  >
                    Remove <i className="fa fa-times" />
                  </button>
                </span>
              </div>
            );
          },
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  deleteLine = (id) => {
    let datatemp = this.state.dataTable;

    if (window.confirm("Are you sure to delete this line?")) {
      // alert("ok");
      let getIndex = _.findIndex(datatemp, function (o) {
        return parseInt(o.CUSTOMER_TRX_ID) === parseInt(id);
      });
      datatemp.splice(getIndex, 1);
    }

    this.setState({ dataTable: datatemp });
    console.log(this.state.dataTable);
    //

    // this.renderTable();
  };

  handleCancel = () => {
    window.location.reload();
  };

  handleSubmit = (e) => {
    if (this.validateSubmit()) {
      let {
        dataTable,
        sAwbDate,
        sAwbNumber,
        sCustomerId,
        sCustomerName,
        sPopular_name,
        sCabangId,
        sCabangName,
        sDest,
        user,
        sDocNumber,
        sDocDate,
        sRO,
      } = this.state;
      // awb_no, awb_date, status, action_type, org_source,source_name,org_destination," +
      //         " destination_name, submitted_by, role_submit, submitted_date, confirmed_by, role_confirmed," +
      //         " confirmed_date, remarks, updated_by, update_date

      let param = {
        awb_no: sAwbNumber,
        awb_date:
          sAwbDate != "" ? moment(sAwbDate).format("YYYY-MM-DD") : "",
        doc_number: "",
        doc_date: moment(sDocDate).format("YYYY-MM-DD"),
        status: "WAITING", // waiting
        destination: sDest,
        org_id_source: user.org_id,
        org_name_source: user.org_name,
        org_id_dest: sDest == "CAB" ? sCabangId : user.org_id,
        org_name_dest: sDest == "CAB" ? sCabangName : user.org_name,
        customer_id: sCustomerId,
        customer_name: sCustomerName,
        popular_name: sPopular_name,
        submitted_by: user.username,
        role_submit: user.role_name,
        updated_by: user.username,
        dataLine: dataTable,
        ro: sRO,
      };

      console.log(param);

      this.setState({ loading: true });
      let url = "/api/collect/v1/monitoring/submit-doc-monitoring";
      request.postCollect(url, param, {
        success: function (response) {
          let { message, data } = response.data;
          window.scrollTo(0, 0);
          this.setState({
            loading: false,
            success: message,
            error: [],
            submitted_stat: true,
            filePATH: data,
          });
          window.setTimeout(() => {
            window.location.reload();
            // this.createPdf.bind(this);
            // window.open(this.state.filePATH, "_blank");
          }, 2000);
        }.bind(this),
        error: function (e) {
          console.log(e);
        },
      });
    }
  };

  handleReopenpdf = (e) => {
    window.open(this.state.filePATH, "_blank");
  };

  renderButton = () => {
    if (this.state.submitted_stat) {
      return (
        <div className="col-md-9">
          <div className="col-sm-8">
            <button
              type="button"
              className="btn btn-success"
              // onClick={this.createPdf.bind(this)}
              onClick={this.handleReopenpdf.bind(this)}
            >
              re-Open PDF
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="col-md-9">
          <div className="col-sm-8">
            <button
              type="button"
              className="btn btn-success"
              onClick={this.handleSubmit.bind(this)}
            >
              Submit
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-danger"
              onClick={this.handleCancel.bind(this)}
            >
              Cancel
            </button>
          </div>
        </div>
      );
    }
  };

  // createPdf = () => {
  //   let {
  //     dataTable,
  //     sAwbDate,
  //     sAwbNumber,
  //     sCustomerId,
  //     sCustomerName,
  //     sCabangId,
  //     sCabangName,
  //     sDest,
  //     user,
  //   } = this.state;
  //   // awb_no, awb_date, status, action_type, org_source,source_name,org_destination," +
  //   //         " destination_name, submitted_by, role_submit, submitted_date, confirmed_by, role_confirmed," +
  //   //         " confirmed_date, remarks, updated_by, update_date

  //   let param = {
  //     awb_no: sAwbNumber,
  //     awb_date: moment(sAwbDate).format("YYYY-MM-DD"),
  //     status: "P",
  //     action_type: sDest,
  //     org_id_source: user.org_id,
  //     org_name_source: user.org_name,
  //     org_id_dest: sDest == "CUS" ? user.org_id : sCabangId,
  //     org_name_dest: sDest == "CUS" ? user.org_name : sCabangName,
  //     customer_id: sCustomerId,
  //     customer_name: sCustomerName,
  //     submitted_by: user.username,
  //     role_submit: user.role_name,
  //     updated_by: user.username,
  //     dataLine: dataTable,
  //   };
  //   let url = "/api/collect/v1/monitoring/create-pdf";

  //   this.setState({ loading: true });
  //   requester.postCollect(url, param, {
  //     success: function (response) {
  //       let { data } = response.data;
  //       if (response.status == 200) {
  //         console.log(response.data.filepath);
  //         // alert(response);
  //         this.setState({ filePATH: response.data.filepath });

  //         window.open(response.data.filepath, "_blank");
  //       }

  //       this.setState({
  //         loading: false,
  //       });
  //     }.bind(this),
  //     error: function (e) {
  //       this.setState({ loading: false });
  //     }.bind(this),
  //   });

  // };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fas fa-check"></i> {this.state.success}
        </div>
      );
    }
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-body">
                    {this.showSuccess()}
                    {this.showError()}
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Destination
                            </label>
                            <div className="col-sm-8">
                              <select
                                className="form-control"
                                name="destId"
                                onChange={this.handleChangeDest.bind(this)}
                              >
                                <option value="CAB">AAM Branch Office</option>
                                <option value="CUS">Customer</option>
                                <option value="RO">RO</option>
                              </select>
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Document No.
                            </label>
                            <div className="col-sm-8">
                              <input
                                disabled
                                placeholder="Doc. Number will be generated after submit"
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                // placeholder="AWB Number"
                                onChange={this.handleChangeDoc.bind(this)}
                              // defaultValue={this.state.sAwbNumber}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Awb No.
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                // placeholder="AWB Number"
                                onChange={this.handleChangeAwb.bind(this)}
                              // defaultValue={this.state.sAwbNumber}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Doc type
                            </label>
                            <div className="col-sm-8">
                              <select
                                className="form-control"
                                name="destId"
                                onChange={this.handleChangeDoctype.bind(this)}
                              >
                                <option value="INV">Invoice No</option>
                                <option value="TTF">Tanda Terima Faktur</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          {this.renderSite()}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Document Date
                            </label>
                            <div className="col-sm-8">
                              <DatePicker
                                disabled
                                selected={this.state.sDocDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                              // value={this.state.sDocDate}
                              // onChange={this.handleChangeDocDate}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Awb Date
                            </label>
                            <div className="col-sm-8">
                              <DatePicker
                                selected={this.state.sAwbDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleChangeAwbDate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Transaction No.
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="scanfield"
                                name="ref_number"
                                placeholder="Place your cursor here for scan"
                                // onChange={this.handleChangeInputScan.bind(this)}
                                onKeyDown={this.handleKeyDown.bind(this)}
                              // value={this.state.ref_number}
                              />
                            </div>
                          </div>
                        </div>

                        {/* {this.renderScan()} */}
                      </div>
                      {/* <hr />

                      <hr />
                      <div className="form-group row">
                        <div className="col-sm-8">
                          <button
                            type="button"
                            className="btn btn-info"
                            onClick={this.handleInsert.bind(this)}
                          >
                            Check Document
                          </button>
                        </div>
                      </div> */}
                      {this.renderTable()}
                      <hr />
                      <div className="form-group row">
                        {this.renderButton()}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default SendDocument;
